import { makeStyles } from "@mui/styles";

const projectStyle = makeStyles((theme) => ({
  container: {
    paddingLeft: '7rem',
    paddingRight: '7rem',
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingTop: "5rem",
    paddingBottom: "2rem",
    width: "100%",
    backgroundColor: theme.palette.background.gray,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '6rem',
      paddingRight: '6rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '3.5rem',
      paddingRight: '3.5rem',
      alignItems: "center",
    },
  },
  header: {
    fontWeight: "bold",
    fontSize: "2rem",
    marginBottom: "1.8rem !important",
    textAlign: "left",
    width: "100%",
    paddingTop:"1.2rem",
    [theme.breakpoints.down('lg')]: {
      paddingTop:"0rem",
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: "center",
      fontSize: "2.4rem!important",
      paddingTop:"0.6rem",
      paddingBottom: "1.2rem",
    },
  },
  paragraph: {
    paddingTop:"1rem",
    fontSize: "1.2rem !important",
    color: theme.palette.text.lightGray,
    marginBottom: "3rem !important",
    textAlign: "justify",
    [theme.breakpoints.down('lg')]: {
      fontSize: "1.2rem !important",
      paddingTop:"1rem",
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: "justify",
      fontSize: "1.4rem !important",
    },
  },
  cardsContainer: {
    display: "flex",
    gap: "2rem",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    marginTop: "2rem",
    [theme.breakpoints.down('lg')]: {
      marginTop: "1rem",
    },
  },
  card: {
    position: "relative",
    borderRadius: "15px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    width: "350px",
    height: "380px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.55)",
      zIndex: 1,
    },
    [theme.breakpoints.down("lg")]: {
      width: "295px",
      height: "325px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "270px",
      height: "320px",
    },
  },
  image: {
    flex: 1 ,
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "absolute",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    zIndex: 0,
  },
  content: {
    position: "relative",
    zIndex: 2,
    color: "#fff",
    padding: "1.5rem 1rem",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
  },
  icon: {
    position: "relative",
    display: "block",
    margin: "0 auto",
    marginTop: "4rem",
    marginBottom: "1rem",
    width: "60px",
    height: "60px",
    zIndex: 2 ,
    [theme.breakpoints.down("lg")]: {
      marginTop: "2rem",
    },
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    margin: "2rem",
    paddingTop: "1.5rem",
    paddingBottom: "0.5rem",
    textAlign: "center",
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.15rem!important",
      paddingTop: "1rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem!important",
      paddingTop: "0.8rem!important",
      paddingRight:"1rem",
      paddingBottom: "0rem",
    },
  },
  description: {
    fontSize: "0.85rem !important",
    color: theme.palette.text.white,
    margin: "0 1rem 1rem",
    textAlign: "center",
    [theme.breakpoints.down("lg")]: {
      paddingTop: "1rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem!important",
      paddingTop: "0.8rem!important",
      paddingBottom: "0rem",
    },
  },
  linkButton: {
    border: "2px solid red",
    marginTop: "2rem !important",
    alignSelf: "center",
    color: ' rgba(255, 255, 255, 0.7) !important',
    backgroundColor: "#fff",
    padding: "1rem 1rem",
    borderRadius: "5px",
    textTransform: "none",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    position: "relative",
    zIndex: 3,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem!important",
      paddingTop: "0.8rem!important",
      paddingBottom: "0rem",
    },
  },
  mobileCarouselContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    maxWidth: "400px",
    margin: "0 auto",
  },
  navWrapper: {
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navButton: {
    backgroundColor: "#ffffff",
    color: "#000",
    zIndex: 10,
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    "& svg": {
      fontSize: "2rem !important",
    },
  },
  "& .MuiIconButton-root:first-of-type": {
    left: 10,
  },
  "& .MuiIconButton-root:last-of-type": {
    right: 10,
  },
  leftNav: {
    left: "5px",
  },
  cardWrapper: {
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    maxWidth: "100%",
  },
  rightNav: {
    right: "1px",
  },
  navPlaceholder: {
    width: "40px",
    height: "40px",
    visibility: "hidden",
  },
}));

export default projectStyle;